module.exports = __webpack_public_path__ + "68bafa0d16b51ec220b0bcc547963664.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/bg.jpg
 ** module id = 737
 ** module chunks = 0
 **/